import React from "react";
import { Table } from "reactstrap";

import ShellCard from "components/ShellCard";

import { fmtInt } from "../../ConferenciaFatura/formatters";
import renderEstadoSecao from "./EstadoSecao";

const EYEBROW = "Quem executa";
const TITULO = "Transições por executor";
const DESCRICAO =
  "Cada linha do histórico de conciliação tem um autor. Aqui elas viram o placar de quem move a fatura no período — o AutoPilot e as pessoas, lado a lado.";

const fmtPct = (parte, total) =>
  total > 0
    ? `${Number((parte / total) * 100).toLocaleString("pt-BR", {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
      })}%`
    : "-";

/**
 * Seção da H3 (PO1-3001): throughput por executor. O kickoff mostrou que hoje
 * quase tudo é AutoPilot (usuário 274); a leitura útil é justamente essa —
 * quanto da esteira roda sozinha e o que sobra para uma pessoa.
 */
export default function Executores({ estado }) {
  const bloqueio = renderEstadoSecao(estado, "Nenhuma transição de fatura no período.");

  if (bloqueio) {
    return (
      <ShellCard eyebrow={EYEBROW} title={TITULO} description={DESCRICAO}>
        {bloqueio}
      </ShellCard>
    );
  }

  const { executores, totais } = estado.data;
  const total = (totais.autopilot || 0) + (totais.humano || 0);

  return (
    <ShellCard eyebrow={EYEBROW} title={TITULO} description={DESCRICAO}>
      <div className="lt-aging-resumo">
        <div>
          <span className="lt-aging-resumo__label">Transições no período</span>
          <strong>{fmtInt(total)}</strong>
        </div>
        <div>
          <span className="lt-aging-resumo__label">AutoPilot</span>
          <strong>
            {fmtInt(totais.autopilot)}{" "}
            <span className="lt-aging-resumo__sufixo">
              ({fmtPct(totais.autopilot, total)})
            </span>
          </strong>
        </div>
        <div>
          <span className="lt-aging-resumo__label">Pessoas</span>
          <strong>
            {fmtInt(totais.humano)}{" "}
            <span className="lt-aging-resumo__sufixo">
              ({fmtPct(totais.humano, total)})
            </span>
          </strong>
        </div>
        <div>
          <span className="lt-aging-resumo__label">Executores</span>
          <strong>{fmtInt(executores.length)}</strong>
        </div>
      </div>

      {executores.length === 0 ? (
        <div className="lt-state">Nenhuma transição de fatura no período.</div>
      ) : (
        <div className="lt-table-wrap">
          <Table className="lt-table" responsive>
            <thead>
              <tr>
                <th>Executor</th>
                <th className="lt-num">Validações</th>
                <th className="lt-num">Liberações</th>
                <th className="lt-num">Bloqueios</th>
                <th className="lt-num">Contestações</th>
                <th className="lt-num">Integrações</th>
                <th className="lt-num">Estornos</th>
                <th className="lt-num">Total</th>
              </tr>
            </thead>
            <tbody>
              {executores.map((e) => (
                <tr key={`${e.userId}-${e.userName || e.nome}`}>
                  <td>
                    <span className="lt-executor">
                      <span className="lt-executor__nome">{e.nome}</span>
                      <span
                        className={`lt-tag lt-tag--${
                          e.tipo === "autopilot" ? "auto" : "humano"
                        }`}
                      >
                        {e.tipo === "autopilot" ? "AutoPilot" : "Pessoa"}
                      </span>
                    </span>
                  </td>
                  <td className="lt-num">{fmtInt(e.validacoes)}</td>
                  <td className="lt-num">{fmtInt(e.liberacoes)}</td>
                  <td className="lt-num">{fmtInt(e.bloqueios)}</td>
                  <td className="lt-num">{fmtInt(e.contestacoes)}</td>
                  <td className="lt-num">{fmtInt(e.integracoes)}</td>
                  <td className="lt-num">{fmtInt(e.estornos)}</td>
                  <td className="lt-num">
                    <strong>{fmtInt(e.total)}</strong>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )}
    </ShellCard>
  );
}
